import { useEffect, useState } from 'react';
import { MA } from '../utils/constants';

export const useMACheckAvailability = ({ anchorItem, skip }) => {
  const isAppliance = anchorItem?.identifiers?.productType === MA;
  const shouldCheckAvailability = isAppliance && !skip;

  const [isAvailable, setIsAvailable] = useState(!shouldCheckAvailability);
  const [applianceDeliveryStore, setApplianceDeliveryStore] = useState(null);
  const [isLoading, setIsLoading] = useState(shouldCheckAvailability);

  useEffect(() => {
    const cb = (event) => {
      const availabilityStatus = event.output?.processedData?.defaultMessagingStatusToUse || '';
      const primaryStoreNumber = event.output?.processedData
        ?.products?.find((product) => !!product.primaryStoreNumber)?.primaryStoreNumber || null;

      if (shouldCheckAvailability) {
        setIsAvailable(availabilityStatus === 'AVAILABLE' || availabilityStatus === 'BACK_ORDERED');
        setApplianceDeliveryStore(primaryStoreNumber);
        setIsLoading(false);
      }
    };

    LIFE_CYCLE_EVENT_BUS.lifeCycle.on('check-availability.depot-direct-success', cb);

    return () => {
      LIFE_CYCLE_EVENT_BUS.lifeCycle.off('check-availability.depot-direct-success', cb);
    };
  }, [shouldCheckAvailability]);

  return {
    isLoading,
    isAvailable,
    applianceDeliveryStore,
  };
};
